import React from 'react';

import {
  SearchResult,
} from '../../../components';

import GroupedContentFull from '../GroupedContent/Full';
import NewsTeaser from './teaser';
import NewsTeaserLarge from './teaser_large';

const News = ({ entity, className, viewMode, ...props }) => {
  switch (viewMode) {
    case 'search_result':
      return (<SearchResult entity={entity} {...props} />);
    case 'teaser':
      return (<NewsTeaser entity={entity} {...props} />);
    case 'teaser_large':
      return (<NewsTeaserLarge entity={entity} {...props} />);
    case 'full':
    default:
      return (<GroupedContentFull entity={entity} {...props} />);
  }
};

export default News;
